import { render, staticRenderFns } from "./CustomValueOccurrence.vue?vue&type=template&id=298a2b52"
import script from "./CustomValueOccurrence.vue?vue&type=script&lang=js"
export * from "./CustomValueOccurrence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports